import React from "react";
import { InstagramLogo, YoutubeLogo, FacebookLogo, XLogo } from "@phosphor-icons/react";

const NETWORKS = [
  { key: "instagram", Icon: InstagramLogo, color: "#E4405F", prefix: "https://instagram.com/" },
  { key: "youtube", Icon: YoutubeLogo, color: "#FF0000", prefix: "https://youtube.com/@" },
  { key: "facebook", Icon: FacebookLogo, color: "#1877F2", prefix: "https://facebook.com/" },
  { key: "twitter", Icon: XLogo, color: "#FFFFFF", prefix: "https://x.com/" },
];

function toUrl(prefix, raw) {
  if (!raw) return "";
  const v = String(raw).trim();
  if (v.startsWith("http://") || v.startsWith("https://")) return v;
  return prefix + v.replace(/^@/, "");
}

export default function SocialLinks({ user, className = "" }) {
  const available = NETWORKS.filter(n => user?.[n.key]);
  if (available.length === 0) return null;
  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`} data-testid="social-links">
      {available.map(({ key, Icon, color, prefix }) => (
        <a
          key={key}
          href={toUrl(prefix, user[key])}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`social-link-${key}`}
          title={key}
          className="w-9 h-9 rounded-full bg-[#1C1C22] border border-white/10 grid place-items-center hover:scale-110 transition-transform"
          style={{ color }}
        >
          <Icon size={18} weight="fill" />
        </a>
      ))}
    </div>
  );
}
